import React, { useState } from "react";
import { Drawer } from "@mantine/core";
import EmptyStateContainer from "../../../themes/components/EmptyStateContainer";
import TagForm from "./TagForm";

const TagTableEmptyStateContainer: React.FC = () => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Drawer
        opened={opened}
        size="xl"
        onClose={() => setOpened(false)}
        title="Create a Tag"
        overlayOpacity={0.1}
        overlayBlur={3}
        position="right"
      >
        <div style={{ padding: "25px", height: "80%", overflow: "auto" }}>
          <TagForm onSuccess={() => setOpened(false)} />
        </div>
      </Drawer>
      <EmptyStateContainer
        title="You have no tags"
        description="Group employees into departments"
        button={{
          onClick: () => setOpened(true),
          title: "Create Tags",
        }}
      />
    </>
  );
};

export default TagTableEmptyStateContainer;
